import React, { useEffect, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import { delet, get } from '../../service/api';
import ButtonsPagination from '../../shared/components/buttons/pagination';
import ButtonsConsulta from '../../shared/components/buttons/consulta';
import ModalExcluir from '../../shared/components/modals/modal-excluir';
import MsgErroTable from '../../shared/components/util/msg-erro-table';
import { CurrencyMask } from '../../shared/helper/helperutil';
import HeaderForConsulta from '../../shared/components/util/header-for-consulta';
import Tecido from '../../models/Tecido';

const ConsultaTecido = (props: Readonly<any>) => {

    const [limitPagination, setLimitPagination] = useState<number>(5);
    const [page, setPage] = useState<Array<Number>>([]);
    const [pag, setPag] = useState<number>(0);
    const [modalExcluir, setModalExcluir] = useState<boolean>(false);
    const [searchElement, setSearchElement] = useState<string>('');
    const [msg, setMsg] = useState('');
    const [quantityItens, setQuantityItens] = useState(0);

    const [list, setList] = useState<Array<Tecido>>([]);
    const [idSelected, setIdSelected] = useState<string>('');

    useEffect( () => {
        setMsg(props.location.query.msg || '');
        getList()
    },[]);

    useEffect( () => getList() ,[pag, searchElement, limitPagination]);

    useEffect( () => {
        const newPage:Array<Number> = new Array();
        const maximumPagination = quantityItens / limitPagination;
        for(let item = 0; item < maximumPagination; item++){
            newPage.push(item)
        }
        setPage(newPage);
    } ,[quantityItens, limitPagination]);

    useEffect( () => {
        setPag(0)
        setLimitPagination(5);
        setList([])
        getList();
        setIdSelected(``);
    } ,[msg, searchElement]);

    const getList: () => void = async () => {
        const url = `/tecido?limit=${limitPagination}&skip=${limitPagination * pag}&name=${searchElement}`;
        const repository = await get(url);
        setQuantityItens(repository.total);
        setList(repository.docs);
    }

    const deleteItem = async () => {
        await delet(`/tecido/${idSelected}`);
        handleClose();
        setMsg('excluído');   
    }
    
    const handleClose = () => setModalExcluir(false);

    const handleShow = (item) => {
        setIdSelected(item);
        setModalExcluir(true);
    }

    const backPage = () => setPag( pag - 1 );

    const nextPage = () => setPag( pag + 1 );

    const search = (e) => setSearchElement(e);
    
    const changePagination = (e) => {
        setLimitPagination(e)
        setPag(0);
    };

    const changePag = (e) => setPag(e);

    return (
        <div>
            <HeaderForConsulta
                component='Tecidos'
                msg={msg}
                search={search}
                name={searchElement}
                changePagination={changePagination}
                list={list.length}
                valueSelect={limitPagination}
            />
            <table className="table table-hover">
                <thead className="thead-dark">
                    <tr>
                        <th></th>
                        <th scope="col">Nome</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Valor m2</th>
                        <th scope="col">Largura</th>
                        <th scope="col">Gramatura</th>
                    </tr>
                </thead>
                <tbody>
                    {list.length > 0 ? list.map((tecido:Tecido) =>
                        <tr key={tecido._id}>
                            <td>
                                <ButtonsConsulta url={`alterar-tecido?id=${tecido._id}`}
                                  click={() => handleShow(tecido._id)}
                                />
                            </td>
                            <td>{tecido.nome}</td>
                            <td>{tecido.descricao}</td>
                            <td>
                                <CurrencyFormat displayType={'text'}
                                    value={tecido.valorM2} format={CurrencyMask}>
                                </CurrencyFormat>
                            </td>
                            <td>
                                <CurrencyFormat thousandSeparator={true} suffix={'m '} displayType={'text'}
                                    value={tecido.largura} >
                                </CurrencyFormat>
                            </td>
                            <td>{tecido.gramatura}</td>
                        </tr>
                    ) : <MsgErroTable colunas="6" />
                    }
                </tbody>
            </table>
            <ButtonsPagination
                currentElement={ (e) => changePag(e) }
                page={page}
                currentPage={pag}
                nextPage={nextPage}
                backPage={backPage}
            />
            <ModalExcluir 
                texto={`Tecido`}
                show={modalExcluir}
                hide={handleClose}
                delete={deleteItem}
            />
        </div>
    );
}

export default ConsultaTecido;